<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM MÃ ĐỀ THI</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="px-6 py-0">
        <v-form v-bind="this.$attrs" ref="form">
          <div class="pt-6">
            <!-- Mã đề thi -->
            <v-text-field
              label="Mã đề thi"
              v-model="examVariant.code"
              outlined
              dense
              required
              class="required mb-4"
              :rules="[
                $rules.required,
                v => /^[0-9]{3}$/.test(v) || 'Mã đề phải là 3 chữ số (vd: 101)'
              ]"
              hint="Nhập 3 chữ số, ví dụ 101"
              persistent-hint
            ></v-text-field>

            <!-- Chọn kỳ thi -->
            <v-select
              label="Kỳ thi"
              :items="exams"
              item-text="name"
              item-value="id"
              v-model="examVariant.exam"
              outlined
              dense
              class="required mb-4"
              :rules="[$rules.required]"
            ></v-select>

            <!-- Chọn tổ hợp môn -->
            <v-select
              label="Tổ hợp môn"
              :items="subjectGroups"
              item-text="name"
              item-value="id"
              v-model="examVariant.subjectGroup"
              outlined
              dense
              class="required mb-4"
              :rules="[$rules.required]"
              :disabled="!examVariant.exam"
            ></v-select>

            <!-- Chọn môn (lọc theo tổ hợp) -->
            <v-select
              v-if="filteredSubjects.length"
              label="Môn thi"
              :items="filteredSubjects"
              item-text="name"
              item-value="id"
              v-model="selectedSubject"
              outlined
              dense
              class="required mb-4"
              :rules="[$rules.required]"
              :disabled="!examVariant.subjectGroup"
            ></v-select>
          </div>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    state: Boolean
  },
  data() {
    return {
      exams: [],
      subjectGroups: [],
      dialog: false,
      selectedSubject: null,
      examVariant: {
        code: "101",
        exam: null,
        subjectGroup: null,
        subjects: [],
        scores: this.getDefaultScores()
      }
    };
  },
  computed: {
    filteredSubjects() {
      const sg = this.subjectGroups.find(
        (sg) => sg.id === this.examVariant.subjectGroup
      );
      return sg ? sg.subjects : [];
    }
  },
  watch: {
    state(val) {
      this.dialog = val;
      if (!val) this.resetForm();
    },
    dialog(val) {
      if (!val) this.$emit("closeDialog");
    },
    async "examVariant.exam"(id) {
      if (id) {
        this.$loading.active = true;
        this.subjectGroups = await this.fetchSubjectGroups({
          exam: id,
          _sort: "index:asc"
        });
        this.$loading.active = false;
        this.examVariant.subjectGroup = null;
        this.selectedSubject = null;
      } else {
        this.subjectGroups = [];
      }
    }
  },
  methods: {
    ...mapActions("examVariant", ["createExamVariant"]),
    ...mapActions("exam", ["fetchExams"]),
    ...mapActions("subjectExamGroup", ["fetchSubjectGroups"]),

    close() {
      this.dialog = false;
      this.$refs.form.resetValidation();
    },
    getDefaultScores() {
      return {
        part1: Array.from({ length: 20 }, () => 0.25),
        part2: [
          "1a","1b","1c","1d",
          "2a","2b","2c","2d",
          "3a","3b","3c","3d",
          "4a","4b","4c","4d",
          "5a","5b","5c","5d",
          "6a","6b","6c","6d",
          "7a","7b","7c","7d",
          "8a","8b","8c","8d"
        ].map(q => ({
          q,
          scores: [0.1, 0.25, 0.5, 1]
        })),
        part3: {
          math:   [0.5, 0.5, 0.5, 0.5, 0.5, 0.5],
          others: [0.25, 0.25, 0.25, 0.25, 0.25, 0.25]
        }
      };
    },
    async getExams() {
      this.$loading.active = true;
      this.exams = await this.fetchExams({ status: "active" });
      this.$loading.active = false;
    },
    resetForm() {
      this.examVariant = {
        code: "101",
        exam: null,
        subjectGroup: null,
        subjects: [],
        scores: this.getDefaultScores()
      };
      this.subjectGroups = [];
      this.selectedSubject = null;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true;
        const payload = {
          ...this.examVariant,
          subjects: this.selectedSubject ? [this.selectedSubject] : []
        };
        const created = await this.createExamVariant(payload);
        this.$loading.active = false;
        if (created) {
          this.resetForm();
          this.close();
          this.$emit('updated');
        }
      }
    }
  },
  async mounted() {
    await this.getExams();
  }
};
</script>
